import service from '@/http/HttpInterceptor.js'
import API_LIST from '@/api/config'

/**
 * 获取session信息
 *
 */
export const getSession = () => {
  return service({
    url: API_LIST.user.info,
    method: 'get'
  })
}
/**
 * 用户登录
 * @params {*} password
 * @params {*} userCode
 */
export const login = (params) => {
  return service({
    url: API_LIST.user.login,
    method: 'post',
    data: params
  })
}

/**
 * 用户登出
 */
export const loginOut = () => {
  return service({
    url: API_LIST.user.loginOut,
    method: 'get'
  })
}
/**
 * 获取短信验证码
 * @params {*} mobile
 */
export const getMsgCode = (params) => {
  return service({
    url: API_LIST.user.getMsgCode,
    method: 'get',
    params: params
  })
}

/**
 * 获取短信验证码
 * @params {*} mobile
 * @params {*} verifyCodes
 * @params {*} pwd
 */
export const register = (params) => {
  return service({
    url: API_LIST.user.register,
    method: 'post',
    data: params
  })
}
/**
 * 校对手机号是否使用过
 * @params {*} mobile
 */
export const judgeMobile = (params) => {
  return service({
    url: API_LIST.user.checkMobile,
    method: 'get',
    params: params
  })
}
/**
 * 修改密码
 * @params {*} pwd
 * @params {*} oldPwd
 */
export const changePsw = (params) => {
  return service({
    url: API_LIST.user.updatePsw,
    method: 'post',
    data: params
  })
}
/**
 * 获取学历
 */
export const getEducation = (params) => {
  return service({
    url: API_LIST.user.education,
    method: 'get',
    params: params
  })
}

/**
 * 获取政治面貌
 */
export const getPoliticalList = (params) => {
  return service({
    url: API_LIST.user.political,
    method: 'get',
    params: params
  })
}
/**
 * 解绑第三方账号
 * @params {*} userType
 */
export const unbindThird = (params) => {
  return service({
    url: API_LIST.user.unBind,
    method: 'post',
    params: params
  })
}
/**
 * 语音搜索
 * @params {*} bytes
 */
export const recordSearch = (params) => {
  return service({
    url: API_LIST.user.record,
    method: 'post',
    data: params
  })
}
/**
 * 清除session中第三方账号绑定失败信息
 */
export const eliminateBindingFlg = (params) => {
  return service({
    url: API_LIST.user.eliminateBindingFlg,
    method: 'get',
    params: params
  })
}
/**
 * 添加收藏
 */
export const addCollectSubstance = (params) => {
  return service({
    url: API_LIST.user.collect,
    method: 'post',
    data: params
  })
}
/**
 * 取消收藏
 */
export const cancleCollectSubstance = (params) => {
  return service({
    url: API_LIST.user.cancleCollect,
    method: 'post',
    data: params
  })
}
/**
 * 获取收藏列表
 */
export const getCollectList = (params) => {
  return service({
    url: API_LIST.user.collectList,
    method: 'get',
    params: params
  })
}
/**
 * 评分
 * @params {*} substanceId
 * @params {*} score
 */
export const scoreContent = (params) => {
  return service({
    url: API_LIST.user.score,
    method: 'post',
    data: params
  })
}
/**
 * 评分
 * @params {*} substanceId
 * @params {*} userId
 */
export const getScoreContent = (params) => {
  return service({
    url: API_LIST.user.getScore,
    method: 'get',
    params: params
  })
}
/**
 * 评分
 * @params {*} verifyCodes
 * @params {*} mobile
 * @params {*} pwd
 */
export const resetPwd = (params) => {
  return service({
    url: API_LIST.user.reSetPsw,
    method: 'post',
    data: params
  })
}

/**
 * 新增留言
 */
export const addFeedBack = (params) => {
  return service({
    url: API_LIST.contribute.add,
    method: 'post',
    data: params
  })
}

/**
 * 更新状态
 */
export const updateFeedBack = (params) => {
  return service({
    url: API_LIST.contribute.update,
    method: 'post',
    data: params
  })
}

/**
 * 获取列表
 */
export const getFeedBackList = (params) => {
  return service({
    url: API_LIST.contribute.list,
    method: 'get',
    params: params
  })
}
/**
 * 新增学习记录
 */
export const addlearn = (params) => {
  return service({
    url: API_LIST.video.addlearn,
    method: 'post',
    data: params
  })
}
export const updatelearn = (params) => {
  return service({
    url: API_LIST.video.updatelearn,
    method: 'post',
    data: params
  })
}
export default Object.assign({
  getSession,
  login,
  loginOut,
  getMsgCode,
  register,
  judgeMobile,
  changePsw,
  getEducation,
  getPoliticalList,
  unbindThird,
  recordSearch,
  eliminateBindingFlg,
  addCollectSubstance,
  cancleCollectSubstance,
  getCollectList,
  scoreContent,
  getScoreContent,
  resetPwd,
  addFeedBack,
  updateFeedBack,
  getFeedBackList,
  addlearn,
  updatelearn
})



// WEBPACK FOOTER //
// ./src/api/interface/interface-list/user.js